export default __webpack_public_path__ + "static/media/loading.bc187367.gif";